import { render, staticRenderFns } from "./OtherSchoolEnrollmentResultRow.vue?vue&type=template&id=fad71a4e&scoped=true"
import script from "./OtherSchoolEnrollmentResultRow.vue?vue&type=script&lang=js"
export * from "./OtherSchoolEnrollmentResultRow.vue?vue&type=script&lang=js"
import style0 from "./OtherSchoolEnrollmentResultRow.vue?vue&type=style&index=0&id=fad71a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad71a4e",
  null
  
)

export default component.exports